import { render } from "./ShoppingGuide.vue?vue&type=template&id=191556cb&scoped=true"
import script from "./ShoppingGuide.vue?vue&type=script&lang=js"
export * from "./ShoppingGuide.vue?vue&type=script&lang=js"

import "./ShoppingGuide.vue?vue&type=style&index=0&id=191556cb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-191556cb"

export default script